/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum DocumentHeaderType {
    UNKNOWN = 'Unknown',
    FILE_UPLOAD = 'FileUpload',
    SHARE_POINT = 'SharePoint',
}
